import gql from 'graphql-tag';

export const mediaCollectionFragment = gql`
  fragment MediaCollection on Page {
    mediaCollection {
      nodes {
        ... on ImageMedia {
          id
          url
        }
      }
    }
  }
`;
